import useCertificationCourseData from './useCertificationCourseData';
import { TABS_CONSTANT } from './constants';

const tabsMapping = {
  [TABS_CONSTANT.OVERVIEW]: { label: 'Overview' },
  [TABS_CONSTANT.CURRICULUM]: { label: 'Curriculum' },
  [TABS_CONSTANT.CASE_STUDIES]: { label: 'Case studies' },
  [TABS_CONSTANT.FACULTIES]: { label: 'Faculty' },
  [TABS_CONSTANT.CERTIFICATION]: { label: 'Certification' },
  [TABS_CONSTANT.SUCCESS_STORIES]: { label: 'Success stories' },
  [TABS_CONSTANT.COURSE_FEE]: { label: 'Course fees' },
  [TABS_CONSTANT.APPLICATION_PROCESS]: { label: 'Application process' },
  [TABS_CONSTANT.FAQs]: { label: 'FAQs' }
};

const useScrollInfo = (goalUID) => {
  const { overAll } = useCertificationCourseData(goalUID);

  const availableSections = overAll?.availableSections ?? [];
  const tabsConfig = availableSections?.reduce((acc, section, index) => {
    return {
      ...acc,
      [section]: {
        ...tabsMapping[section],
        key: section,
        value: index
      }
    };
  }, {});

  return {
    availableSections,
    tabsConfig,
    tabs: Object.values(tabsConfig)
  };
};

export default useScrollInfo;
